import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import './libs/globalComponents.js'
import './assets/global.scss'
import 'viewerjs/dist/viewer.css'
import mixin from "@/libs/mixin";
import "./plugins/vuetify-money.js";
import i18n from './i18n'
import VueMask from "v-mask";

Vue.config.productionTip = false
Vue.use(VueMask)
Vue.mixin(mixin)

new Vue({
  vuetify,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
